var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIllustrationImport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 77,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 28.5H13M47 38.5H13M37 49.5H13"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.049 74h0H5a4 4 0 01-4-4V21.62h0L21.183 1H55a4 4 0 014 4v32.5h0v20.54",
    stroke: "#2B2B2B",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 1.505V18a2.99 2.99 0 01-.879 2.121 2.99 2.99 0 01-2.12.879h0l-16.495-.001L21 1.505z",
    stroke: "#2B2B2B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 75.114v-5.676h15.937a1.31 1.31 0 001.313-1.313v-5.25a1.31 1.31 0 00-1.313-1.312H54V55.89c0-1.17-1.416-1.755-2.242-.93l-9.625 9.61a1.314 1.314 0 000 1.859l9.625 9.614c.831.826 2.242.24 2.242-.93z",
    fill: "#F1822E",
    fillRule: "nonzero"
  }))));
}

export default SvgIllustrationImport;